import { ServiceRequestBase } from "../ServiceRequestBase";

export class SendEmailRequest extends ServiceRequestBase {
  public FromName: string | null = null;
  public FromAddress: string | null = null;
  public Subject: string | null = null;
  public Body: string | null = null;
}
